import type { Dispatch } from "redux";
import actions from "~/shared/actions";

export function resetAntallSider() {
	return (dispatch: Dispatch) => dispatch(actions.resetAntallSider());
}

export function setAntallSider(antall: number) {
	return (dispatch: Dispatch) => dispatch(actions.settAntallSider(antall));
}
